export function isStringHasLowwerLetter(txt: string): boolean {
  return /[a-z]/.test(txt);
}

export function isStringHasUpperLetter(txt: string): boolean {
  return /[A-Z]/.test(txt);
}

export function isStringHasNumber(txt: string): boolean {
  return /\d/.test(txt);
}

export function isStringHasSpecialLetter(txt: string): boolean {
  return /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(txt);
}

export function setProfileFullName(firstName: string, lastName: string): string {
  return (firstName + ' ' + lastName)
    .trim()
    .toLowerCase()
    .replace(/(?:^|\s|-)\S/g, (match: string) => match.toUpperCase());
}

export function normalizeUrl(url: string, ignoredKeyWords?: (string | RegExp)[]): string {
  let normalized = url;
  ignoredKeyWords?.forEach((keyWord) => {
    normalized = normalized.replace(keyWord, '');
  });
  normalized = normalized.replace(/\/$/, '');
  return normalized;
}
